(function initDropdown() {
  if (!window.Vue || !window.Pinia || !window.vehicleSearch || !window.sizeSearch) {
    return setTimeout(initDropdown, 150);
  }
  const { createApp, ref, onMounted, onUnmounted, computed, watch } = Vue;

  const app = createApp({
    delimiters: ['#{', '}'],
    setup() {
      const rego = ref('');
      const showDropdown = ref(false);
      const popup = ref(false);
      const vehicle = ref({});
      const regResponse = ref(false);
      const noRegoInput = ref(false);
      const noStateInput = ref(false);
      const isDuplicate = ref(false);
      const vehicleLoad = ref(false);
      const tempVehicle = ref('');
      const lastRego = ref('');
      const lastRegoState = ref('');
      const activeTab = ref('rego');
      const bestDealsLink = ref(`${shopifyConfig.storeURL}/collections/${shopifyConfig.bestDealsCollection}`);

      const isOnPromoPage = computed(() => String(window.location.pathname || '').toLowerCase().includes('promotions'));
      const browseTyresLink = ref(`${shopifyConfig.storeURL}/collections/${shopifyConfig.tyresCollection}`);
      const browseWheelsLink = ref(`${shopifyConfig.storeURL}/collections/${shopifyConfig.wheelsCollection}`);
      const browseServicesLink = ref(`${shopifyConfig.storeURL}/collections/${shopifyConfig.servicesCollection}`);

      const vehicleSearch = window.vehicleSearch();
      const sizeSearch = window.sizeSearch();
      const uiState = window.uiState();
      const getCollectionHandleForCurrentContext = () => {
        const path = String(window.location.pathname || '').toLowerCase();
        const tyresHandle = String(shopifyConfig?.tyresCollection || 'tyres');
        const wheelsHandle = String(shopifyConfig?.wheelsCollection || 'wheels');
        const productType = String(window.prodType || '').toLowerCase();

        if (path.includes(`/collections/${wheelsHandle.toLowerCase()}`) || path.includes('/collections/wheels')) {
          return wheelsHandle;
        }
        if (path.startsWith('/products/') && productType.includes('wheel')) {
          return wheelsHandle;
        }
        return tyresHandle;
      };

      const resetTyreSizeSelect = async () => {
        sizeSearch.setType('tyre');
        await sizeSearch.getOptions('tyre', 0);
        await ensureWidthCascade();
        await ensureAspectCascade();
        handleDiameterChange();
      }

      const navigateAfterVehicleChange = () => {
        const path = String(window.location.pathname || '').toLowerCase();
        if (path.startsWith('/search') || path.includes('promotions')) {
          const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash || ''}`;
          window.location.href = currentUrl;
          return;
        }
        const handle = getCollectionHandleForCurrentContext();
        const base = String(shopifyConfig?.storeURL || window.location.origin || '').replace(/\/$/, '');
        window.location.href = `${base}/collections/${handle}`;
      };

      const navigateToTyresCollection = () => {
        const base = String(shopifyConfig?.storeURL || window.location.origin || '').replace(/\/$/, '');
        const tyresHandle = String(shopifyConfig?.tyresCollection || 'tyres');
        window.location.href = `${base}/collections/${tyresHandle}`;
      };

      const displayedVehicles = computed(() => vehicleSearch.vehicles.slice(0, 3));
      const vehicleSelector = computed(() => {
        return vehicleSearch.vehicleSelector?.value || vehicleSearch.vehicleSelector || [];
      });

      const selectedWidth = ref('');
      const selectedAspectRatio = ref('');
      const selectedDiameter = ref('');
      const selectedSizeDisplay = ref(localStorage.getItem('selectedSizeDisplay') || '');
      const sizeHistory = ref(JSON.parse(localStorage.getItem('sizeHistory') || '[]'));
      const vehicleMake = ref('');
      const vehicleYear = ref('');
      const vehicleModel = ref('');
      const vehicleSeries = ref('');
      const pendingVehicleModal = ref(false);
      const pendingFitmentId = ref(null);
      const pendingModalFound = ref(null);
      const pendingConfirmedVehicle = ref(null);
      const pendingVehicleFromSelector = ref(false);
      const pendingVehiclePreIds = ref([]);
      const confirmingVehicle = ref(false);
      const regoLookupInFlight = ref(false);
      let regoSearchTimeout = null;
      let handleVehicleUpdatedEvent = null;
      let handleStorageEvent = null;

      const clearVehicleSearchInputs = () => {
        rego.value = '';
        noRegoInput.value = false;
        noStateInput.value = false;
        isDuplicate.value = false;
        vehicleMake.value = '';
        vehicleYear.value = '';
        vehicleModel.value = '';
        vehicleSeries.value = '';
      };

      const clearRegoSearchTimeout = () => {
        if (regoSearchTimeout) {
          clearTimeout(regoSearchTimeout);
          regoSearchTimeout = null;
        }
      };

      const rollbackPendingSelectorVehicle = () => {
        if (!pendingVehicleFromSelector.value) return;
        const pendingId = String(pendingConfirmedVehicle.value?.id || vehicle.value?.id || '');
        const preIds = Array.isArray(pendingVehiclePreIds.value) ? pendingVehiclePreIds.value : [];
        const existedBefore = pendingId && preIds.includes(pendingId);

        if (pendingId && !existedBefore) {
          const idx = vehicleSearch.vehicles.findIndex((v) => String(v?.id) === pendingId);
          if (idx > -1) {
            vehicleSearch.vehicles.splice(idx, 1);
            localStorage.setItem('vehicles', JSON.stringify(vehicleSearch.vehicles));
          }
          if (String(vehicleSearch.activeVehicleId || '') === pendingId) {
            vehicleSearch.clearActiveVehicle();
            window.dispatchEvent(new CustomEvent('vehicle-updated', { detail: null }));
          }
        }

        pendingVehicleFromSelector.value = false;
        pendingVehiclePreIds.value = [];
      };

      const startRegoSearchTimeout = () => {
        clearRegoSearchTimeout();
        regoSearchTimeout = setTimeout(() => {
          vehicleLoad.value = false;
          regoLookupInFlight.value = false;
          if (!popup.value) openModal(false);
        }, 15000);
      };

      const loadVehicleSelector = () => {
        const makes = vehicleSelector.value[0];
        if (!makes || !Array.isArray(makes.options) || makes.options.length === 0) {
          vehicleSearch.retrieveSelectorOptions(0);
        }
      };

      const handleVehicleSelect = (traitIndex, value) => {
        if (!value) return;

        if (traitIndex === 0) {
          vehicleYear.value = '';
          vehicleModel.value = '';
          vehicleSeries.value = '';
        } else if (traitIndex === 1) {
          vehicleModel.value = '';
          vehicleSeries.value = '';
        } else if (traitIndex === 2) {
          vehicleSeries.value = '';
        }

        const options = (vehicleSelector.value[traitIndex] && vehicleSelector.value[traitIndex].options) || [];
        const getOptionValue = (opt) => {
          if (opt && typeof opt === 'object' && 'id' in opt) return String(opt.id);
          return String(opt);
        };
        let optionIndex = options.findIndex((opt) => getOptionValue(opt) === String(value));

        if (traitIndex === 3) {
          return;
        }

        if (optionIndex > -1) {
          vehicleSearch.selectTrait(traitIndex, optionIndex);
        }
        localStorage.removeItem('searchWidgetFilters');
      };

      const versionCheck = () => {
        let localVehicles = localStorage.getItem('vehicles')
        if (localVehicles) {
          try {
            let parsedVehicles = JSON.parse(localVehicles);
            parsedVehicles.map(async (v) => {
              let vData = await vehicleSearch.getFitment(v.vehicle_id)
              if (vData != 'fitFail') {
                v.fitmentInfo = vData;
                let vEntries = Object.entries(vData);
                vEntries.forEach(element => {
                  v[element[0]] = element[1];
                });
              }
              return v;
            })
            localStorage.setItem('vehicles', JSON.stringify(parsedVehicles));
          } catch (e) {
            console.error(`Error retrieving vehicles ${e}`)
          }
        }
        document.removeEventListener("contentReload", versionCheck);
        return;
      }

      document.addEventListener("contentReload", versionCheck)

      onMounted(() => {
        vehicleSearch.loadVehicleArray();
        loadVehicleSelector();
        selectedWidth.value = localStorage.getItem('selectedWidth') || '';
        selectedAspectRatio.value = localStorage.getItem('selectedAspectRatio') || '';
        selectedDiameter.value = localStorage.getItem('selectedDiameter') || '';
        sizeHistory.value = JSON.parse(localStorage.getItem('sizeHistory') || '[]');
        if (!selectedWidth.value && sizeHistory.value.length) {
          selectedWidth.value = sizeHistory.value[0].width || '';
          selectedAspectRatio.value = sizeHistory.value[0].aspect || '';
          selectedDiameter.value = sizeHistory.value[0].diameter || '';
        }
        const storedId = localStorage.getItem('activeVehicleId');
        if (storedId) {
          const exists = vehicleSearch.vehicles.some((v) => String(v.id) === String(storedId));
          if (!exists) vehicleSearch.clearActiveVehicle();
        }
        uiState?.setVehicleDropdownOpen?.(showDropdown.value);
        uiState?.setVehicleModalOpen?.(popup.value);

        handleVehicleUpdatedEvent = (_event) => {
        };
        handleStorageEvent = (event) => {
          if (event?.key === 'activeVehicleId') {
            const id = localStorage.getItem('activeVehicleId') || '';
            if (id) vehicleSearch.setActiveVehicle(id);
            else vehicleSearch.clearActiveVehicle();
          }
        };
        window.addEventListener('vehicle-updated', handleVehicleUpdatedEvent);
        window.addEventListener('storage', handleStorageEvent);
      });

      const activeVehicle = computed(() => {
        return vehicleSearch.vehicles.find((v) => String(v.id) === String(vehicleSearch.activeVehicleId)) || null;
      });

      watch(
        () => vehicleSearch.vehicles.map((v) => v.id),
        (ids) => {
          if (vehicleSearch.activeVehicleId && !ids.some((id) => String(id) === String(vehicleSearch.activeVehicleId))) {
            vehicleSearch.clearActiveVehicle();
          }

          if (
            activeTab.value === 'vehicle' &&
            vehicleSearch.vehicleSelector[3].selectedOption &&
            vehicleSearch.vehicles.length > 0 &&
            !pendingVehicleFromSelector.value
          ) {
            const nextActiveId = String(vehicleSearch.vehicles[0].id);
            if (String(vehicleSearch.activeVehicleId) !== nextActiveId) {
              vehicleSearch.setActiveVehicle(vehicleSearch.vehicles[0].id);
              selectedSizeDisplay.value = '';
              localStorage.removeItem('selectedSizeDisplay');
              localStorage.removeItem('selectedWidth');
              localStorage.removeItem('selectedAspectRatio');
              localStorage.removeItem('selectedDiameter');
              window.dispatchEvent(new CustomEvent('vehicle-updated', { detail: vehicleSearch.vehicles[0] }));
            }
          }

          if (pendingVehicleModal.value && vehicleSearch.vehicles.length > 0) {
            const justAdded = vehicleSearch.vehicles[0];
            pendingConfirmedVehicle.value = justAdded;
            if (!vehicle.value || vehicle.value.id !== justAdded.id) {
              vehicle.value = justAdded;
              openModal(true);
            } else {
              openModal(true);
            }
            pendingVehicleModal.value = false;
          }
        }
      );

      watch(activeTab, (tab) => {
        if (tab === 'vehicle') {
          loadVehicleSelector();
        }
      });

      watch(
        () => (vehicleSelector.value[3] ? vehicleSelector.value[3].options : null),
        (options) => {
          if (activeTab.value === 'vehicle' && Array.isArray(options) && options.length === 1 && !vehicleSeries.value) {
            const first = options[0];
            vehicleSeries.value = first && typeof first === 'object' ? String(first.id || '') : String(first || '');
            handleVehicleSelect(3, vehicleSeries.value);
          }
        }
      );

      const formatVehicleDisplay = (v) => {
        if (!v) return '';
        return `${v.rego} (${v.regoState})`;
      };
      const sanitizeRegoValue = (value) => {
        return String(value || '')
          .replace(/\s+/g, '')
          .replace(/[^a-zA-Z0-9]/g, '')
          .toUpperCase();
      };

      const checkDuplicate = () => {
        const upperRego = sanitizeRegoValue(rego.value);
        if (upperRego.length > 0 && vehicleSearch.regoState.length > 0) {
          isDuplicate.value = vehicleSearch.vehicles.some(
            (v) => (v.rego || '').toUpperCase() === upperRego && v.regoState === vehicleSearch.regoState
          );
        } else {
          isDuplicate.value = false;
        }
      };
      watch(rego, (value) => {
        const cleaned = sanitizeRegoValue(value);
        if (value !== cleaned) {
          rego.value = cleaned;
          return;
        }
        if (cleaned.length > 0) {
          noRegoInput.value = false;
        }
        checkDuplicate();
      });

      const toggleDropdown = () => {
        if (showDropdown.value) {
          showDropdown.value = false;
          return;
        }
        uiState?.setVehicleDropdownOpen?.(false);
        showDropdown.value = true;
        uiState?.setVehicleDropdownOpen?.(true);
      };

      watch(
        () => {
          const value = uiState?.vehicleDropdownOpen;
          if (value && typeof value === 'object' && 'value' in value) return !!value.value;
          return !!value;
        },
        (isOpen) => {
          if (isOpen && !showDropdown.value) {
            showDropdown.value = true;
            changeTab('rego');
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else if (!isOpen && showDropdown.value) {
            showDropdown.value = false;
          }
        }
      );

      watch(showDropdown, async (isOpen) => {
        uiState?.setVehicleDropdownOpen?.(isOpen);
        if (isOpen && activeTab.value === 'size') await resetTyreSizeSelect();
        if (!isOpen && pendingModalFound.value !== null) {
          const found = !!pendingModalFound.value;
          pendingModalFound.value = null;
          setTimeout(() => {
            if (!showDropdown.value) {
              showModalNow(found);
            }
          }, 0);
        }
      });

      const noRego = computed(() => {
        return popup.value && !regResponse.value && !regoLookupInFlight.value ? true : false;
      });

      const yesRego = computed(() => {
        return popup.value && regResponse.value ? true : false;
      });

      const clubRego = computed(() => rego.value !== '' && vehicleSearch.regoState !== '' ? rego.value === 'CCSSAABBAA' && vehicleSearch.regoState === 'VIC' ? true : vehicleSearch.clubRegexes(rego.value,vehicleSearch.regoState) : false);

      const vehicleReady = Vue.computed(() => {
        if (!vehicle.value?.id) return false;
        if (pendingConfirmedVehicle.value && String(pendingConfirmedVehicle.value.id) === String(vehicle.value.id)) {
          return true;
        }
        return vehicleSearch.vehicles.some((v) => String(v.id) === String(vehicle.value.id));
      })
      const canConfirmVehicle = Vue.computed(() => {
        return !!pendingConfirmedVehicle.value?.id && !confirmingVehicle.value;
      });

      const modalOwnerId = `ggvd-${Math.random().toString(36).slice(2)}`;
      const isModalOwner = computed(() => window.__ggVehicleModalOpen === modalOwnerId);

      const showModalNow = (found) => {
        if (window.__ggVehicleModalOpen && window.__ggVehicleModalOpen !== modalOwnerId) {
          return;
        }
        if (found) {
          clearVehicleSearchInputs();
        }
        window.__ggVehicleModalOpen = modalOwnerId;
        regResponse.value = !!found;
        popup.value = true;
        uiState?.setVehicleModalOpen?.(true);
      };

      const openModal = (found) => {
        pendingModalFound.value = !!found;
        uiState?.setVehicleDropdownOpen?.(false);
        if (showDropdown.value) {
          showDropdown.value = false;
          return;
        }
        showModalNow(!!pendingModalFound.value);
        pendingModalFound.value = null;
      };

      const closePopup = () => {
        popup.value = false;
        vehicleLoad.value = false;
        regoLookupInFlight.value = false;
        clearRegoSearchTimeout();
        try {
          resetRecaptcha();
        } catch (e) { }
        uiState?.setVehicleModalOpen?.(false);
        if (window.__ggVehicleModalOpen === modalOwnerId) {
          window.__ggVehicleModalOpen = null;
        }
        retryRego();
      };

      const retryRego = () => {
        rollbackPendingSelectorVehicle();
        pendingConfirmedVehicle.value = null;
        vehicleLoad.value = false;
        regoLookupInFlight.value = false;
        clearRegoSearchTimeout();
        try {
          resetRecaptcha();
        } catch (e) { }
        rego.value = '';
        noRegoInput.value = false;
        noStateInput.value = false;
        isDuplicate.value = false;
      };

      const regoSearch = () => {
        if (vehicleLoad.value) {
          return;
        }

        if (isDuplicate.value) {
          vehicleLoad.value = false;
          clearRegoSearchTimeout();
          return;
        }

        regResponse.value = false;
        popup.value = false;
        pendingConfirmedVehicle.value = null;
        pendingVehicleFromSelector.value = false;
        pendingVehiclePreIds.value = [];
        const normalizedRego = sanitizeRegoValue(rego.value);
        rego.value = normalizedRego;

        if (normalizedRego.length == 0 || vehicleSearch.regoState.length == 0) {
          vehicleLoad.value = false;
          clearRegoSearchTimeout();
          if (normalizedRego.length == 0) {
            noRegoInput.value = true;
          }
          if (vehicleSearch.regoState.length == 0) {
            noStateInput.value = true;
          }
          return;
        } else {
          vehicleLoad.value = true;
          startRegoSearchTimeout();
          noRegoInput.value = false;
          noStateInput.value = false;
          vehicleSearch.regoLPN = normalizedRego;
          lastRego.value = normalizedRego;
          lastRegoState.value = vehicleSearch.regoState;

          if (
            vehicleSearch.vehicles.filter((v) => v.rego == rego.value && v.regoState == vehicleSearch.regoState)
              .length > 0
          ) {
            tempVehicle.value = vehicleSearch.vehicles.filter(
              (v) => v.rego == rego.value && v.regoState == vehicleSearch.regoState
            )[0];
          }

          if (
            tempVehicle?.value?.fitmentInfo?.version == vehicleSearch?.releaseVersion &&
            tempVehicle?.value?.fitmentInfo?.expiry > Date.parse(new Date())
          ) {
            vehicle.value = tempVehicle.value;
            pendingConfirmedVehicle.value = tempVehicle.value;
            openModal(true);
            vehicleLoad.value = false;
            clearRegoSearchTimeout();
            tempVehicle.value = '';
          } else {
            regoLookupInFlight.value = true;
            vehicleSearch.vehicleCall = { status: 'pending', at: Date.now(), source: 'vehicle-dropdown' };
            try {
              grecaptcha.execute();
            } catch (e) {
              vehicleLoad.value = false;
              regoLookupInFlight.value = false;
              clearRegoSearchTimeout();
            }
          }
        }
      };

      const vehicleCall = Vue.computed(() => {
        return vehicleSearch.vehicleCall;
      });

      Vue.watch(vehicleCall, (object) => {
        if (!showDropdown.value && window.location.pathname.toLowerCase().includes('questionnaire')) {
          return;
        }
        if (!regoLookupInFlight.value && (!object || object === 'regoFail')) {
          return;
        }
        if (object && typeof object === 'object' && object.status === 'pending') {
          return;
        }
        if (object == 'regoFail' || !object) {
          clearRegoSearchTimeout();
          regoLookupInFlight.value = false;
          pendingConfirmedVehicle.value = null;
          openModal(false);
          vehicleLoad.value = false;
          try {
            resetRecaptcha();
          } catch (e) { }
          return;
        }

        object.rego = lastRego.value || rego.value;
        object.regoState = lastRegoState.value || vehicleSearch.regoState;

        vehicle.value = object;
        openModal(true);
        vehicleLoad.value = false;
        regoLookupInFlight.value = false;
        clearRegoSearchTimeout();

        if (pendingFitmentId.value === vehicle.value.id) {
          return;
        }
        pendingFitmentId.value = vehicle.value.id;
        vehicleSearch.getFitment(vehicle.value.id).then((fitObject) => {
          if (fitObject == 'fitFail') {
            console.log('Fitment call failed');
          } else {

            let fitVehicle = vehicle.value;

            if (!fitObject?.tyre_fitments[0]?.is_oe) {
              for (let i = 1; i < fitObject.tyre_fitments.length; i++) {
                if (fitObject.tyre_fitments[i].is_oe) {
                  let oeFit = fitObject.tyre_fitments[i];
                  fitObject.tyre_fitments.splice(i, 1);
                  fitObject.tyre_fitments.unshift(oeFit);
                  break;
                }
              }
            }
            const tyreFitment = fitObject?.tyre_fitments?.[0];
            if (tyreFitment?.f_tyres) {
              tyreFitment.f_tyres.filters = vehicleSearch.createFitFilters(tyreFitment.f_tyres);
            }
            if (tyreFitment?.is_split && tyreFitment?.r_tyres) {
              tyreFitment.r_tyres.filters = vehicleSearch.createFitFilters(tyreFitment.r_tyres);
            }

            if (!fitObject?.wheel_fitments[0]?.is_oe) {
              for (let i = 1; i < fitObject.wheel_fitments.length; i++) {
                if (fitObject.wheel_fitments[i].is_oe) {
                  let oeFit = fitObject.wheel_fitments[i];
                  fitObject.wheel_fitments.splice(i, 1);
                  fitObject.wheel_fitments.unshift(oeFit);
                  break;
                }
              }
            }
            const wheelFitment = fitObject?.wheel_fitments?.[0];
            if (wheelFitment?.f_wheels) {
              wheelFitment.f_wheels.filters = vehicleSearch.createFitFilters(wheelFitment.f_wheels);
            }
            if (wheelFitment?.is_split && wheelFitment?.r_wheels) {
              wheelFitment.r_wheels.filters = vehicleSearch.createFitFilters(wheelFitment.r_wheels);
            }

            fitVehicle.fitmentInfo = fitObject;
            fitVehicle.fitmentInfo.version = vehicleSearch.releaseVersion;
            fitVehicle.fitmentInfo.expiry = Date.parse(new Date()) + 24 * (60 * 60 * 1000);
            fitVehicle.manufactureYear = vehicleSearch.manYear(vehicle.value);

            tempVehicle.value = fitVehicle;
            tempVehicle.value.rego = lastRego.value || rego.value;
            tempVehicle.value.regoState = lastRegoState.value || vehicleSearch.regoState;
            delete tempVehicle.value.ip;

            pendingConfirmedVehicle.value = tempVehicle.value;
            vehicle.value = tempVehicle.value;
            tempVehicle.value = '';
          }
        }).finally(() => {
          if (pendingFitmentId.value === vehicle.value.id) {
            pendingFitmentId.value = null;
          }
        });
      });

      Vue.watch(popup, (val) => {
        uiState?.setVehicleModalOpen?.(val);
        if (val) {
          showDropdown.value = false;
        }
      });

      watch(
        () => {
          const value = uiState?.vehicleModalOpen;
          if (value && typeof value === 'object' && 'value' in value) return !!value.value;
          return !!value;
        },
        (isModalOpen) => {
          if (isModalOpen && showDropdown.value) {
            showDropdown.value = false;
          }
        }
      );
      onUnmounted(() => {
        clearRegoSearchTimeout();
        if (handleVehicleUpdatedEvent) {
          window.removeEventListener('vehicle-updated', handleVehicleUpdatedEvent);
        }
        if (handleStorageEvent) {
          window.removeEventListener('storage', handleStorageEvent);
        }
      });
      const vehicleConfirm = async (shouldNavigate = true, targetHref = '') => {
        if (confirmingVehicle.value) return;
        const confirmedVehicle = pendingConfirmedVehicle.value || null;
        if (!confirmedVehicle || !confirmedVehicle.id) {
          closePopup();
          return;
        }
        confirmingVehicle.value = true;

        try {
          let preIndex = vehicleSearch.vehicles.findIndex((v) => String(v.id) === String(confirmedVehicle.id));
          if (preIndex > -1) {
            vehicleSearch.vehicles.splice(preIndex, 1);
          }
          await vehicleSearch.addVehicle(confirmedVehicle);

          const storedVehicles = (() => {
            try { return JSON.parse(localStorage.getItem('vehicles') || '[]'); } catch (e) { return []; }
          })();
          if (!storedVehicles.some((v) => String(v?.id) === String(confirmedVehicle.id))) {
            const merged = [confirmedVehicle, ...vehicleSearch.vehicles.filter((v) => String(v?.id) !== String(confirmedVehicle.id))];
            localStorage.setItem('vehicles', JSON.stringify(merged.slice(0, 3)));
          }

          vehicleSearch.setActiveVehicle(confirmedVehicle.id);
          selectedSizeDisplay.value = '';
          localStorage.removeItem('selectedSizeDisplay');
          localStorage.removeItem('selectedWidth');
          localStorage.removeItem('selectedAspectRatio');
          localStorage.removeItem('selectedDiameter');
          window.dispatchEvent(new CustomEvent('vehicle-updated', { detail: confirmedVehicle }));

          pendingVehicleFromSelector.value = false;
          pendingVehiclePreIds.value = [];
          pendingConfirmedVehicle.value = null;
          closePopup();
          showDropdown.value = false;
          if (targetHref) {
            window.location.href = targetHref;
            return;
          }
          if (shouldNavigate) {
            navigateAfterVehicleChange();
          }
        } finally {
          confirmingVehicle.value = false;
        }
      };

      const persistSizeHistory = () => {
        localStorage.setItem('sizeHistory', JSON.stringify(sizeHistory.value));
      };

      const selectVehicle = (v) => {
        vehicleSearch.setActiveVehicle(v.id);
        localStorage.removeItem('searchWidgetFilters');
        selectedSizeDisplay.value = '';
        localStorage.removeItem('selectedSizeDisplay');
        localStorage.removeItem('selectedWidth');
        localStorage.removeItem('selectedAspectRatio');
        localStorage.removeItem('selectedDiameter');

        const vehicleIndex = vehicleSearch.vehicles.indexOf(v);
        if (vehicleIndex > 0) {
          vehicleSearch.vehicles.splice(vehicleIndex, 1);
          vehicleSearch.vehicles.unshift(v);
          localStorage.setItem('vehicles', JSON.stringify(vehicleSearch.vehicles));
        }

        window.dispatchEvent(
          new CustomEvent('vehicle-updated', {
            detail: v,
          })
        );

        showDropdown.value = false;
        navigateAfterVehicleChange();
      };

      const selectSizeHistory = (idx) => {
        const size = sizeHistory.value[idx];
        if (!size) return;

        if (idx > 0) {
          sizeHistory.value.splice(idx, 1);
          sizeHistory.value.unshift(size);
          persistSizeHistory();
        }

        selectedWidth.value = size.width;
        selectedAspectRatio.value = size.aspect;
        selectedDiameter.value = size.diameter;
        selectedSizeDisplay.value = size.display;

        localStorage.setItem('selectedSizeDisplay', size.display);
        localStorage.setItem('selectedWidth', size.width);
        localStorage.setItem('selectedAspectRatio', size.aspect);
        localStorage.setItem('selectedDiameter', size.diameter);

        vehicleSearch.clearActiveVehicle();

        sizeSearch.setType('tyre');
        sizeSearch.getOptions('tyre', 0);

        handleWidthChange(false);
        setTimeout(() => {
          handleAspectRatioChange(false);
          setTimeout(() => {
            handleDiameterChange();
          }, 0);
        }, 0);

        let filters = [
          {
            productMetafield: {
              namespace: 'wheel_tyre_spec',
              key: 'width',
              value: size.width,
            },
          },
          {
            productMetafield: {
              namespace: 'tyre_spec',
              key: 'aspect_ratio',
              value: size.aspect,
            },
          },
          {
            productMetafield: {
              namespace: 'wheel_tyre_spec',
              key: 'rim_diameter',
              value: size.diameter,
            },
          },
        ];

        localStorage.setItem('searchWidgetFilters', JSON.stringify(filters));

        window.dispatchEvent(
          new CustomEvent('vehicle-updated', {
            detail: {
              searchType: 'size',
              size: size.display,
              filters: filters,
            },
          })
        );

        showDropdown.value = false;

        navigateToTyresCollection();
      };

      const removeVehicle = (index) => {
        const vehicleToRemove = vehicleSearch.vehicles[index];
        const wasActive = vehicleToRemove && String(vehicleToRemove.id) === String(vehicleSearch.activeVehicleId);

        vehicleSearch.deleteVehicle(vehicleToRemove);
        localStorage.setItem('vehicles', JSON.stringify(vehicleSearch.vehicles));

        checkDuplicate();

        if (wasActive) {
          const nextVehicle = null;
          vehicleSearch.clearActiveVehicle();
          window.dispatchEvent(
            new CustomEvent('vehicle-updated', {
              detail: nextVehicle || null,
            })
          );
        }
        window.dispatchEvent(new CustomEvent('vehicleChanged'));
      };

      const removeSizeSearch = (idx) => {
        if (idx >= 0 && idx < sizeHistory.value.length) {
          const removed = sizeHistory.value.splice(idx, 1)[0];
          persistSizeHistory();
          if (removed && removed.display === selectedSizeDisplay.value) {
            selectedSizeDisplay.value = '';
            selectedWidth.value = '';
            selectedAspectRatio.value = '';
            selectedDiameter.value = '';
            localStorage.removeItem('selectedSizeDisplay');
            localStorage.removeItem('selectedWidth');
            localStorage.removeItem('selectedAspectRatio');
            localStorage.removeItem('selectedDiameter');
            window.dispatchEvent(
              new CustomEvent('vehicle-updated', {
                detail: null,
              })
            );
          }
        }
      };

      const clearSelection = () => {
        vehicleSearch.clearActiveVehicle();
        selectedSizeDisplay.value = '';
        selectedWidth.value = '';
        selectedAspectRatio.value = '';
        selectedDiameter.value = '';
        localStorage.removeItem('selectedSizeDisplay');
        localStorage.removeItem('selectedWidth');
        localStorage.removeItem('selectedAspectRatio');
        localStorage.removeItem('selectedDiameter');
        localStorage.removeItem('searchWidgetFilters');
        window.dispatchEvent(
          new CustomEvent('vehicle-updated', {
            detail: null,
          })
        );
        window.dispatchEvent(new CustomEvent('vehicleChanged'));

        showDropdown.value = false;
      };

      const changeTab = async (tab) => {
        activeTab.value = tab;
        if (tab === 'size') await resetTyreSizeSelect();
      };

      const handleWidthChange = async (resetDependents = true) => {
        if (resetDependents) {
          selectedAspectRatio.value = '';
          selectedDiameter.value = '';
        }
        if (selectedWidth.value) {
          const optionIndex = sizeSearch.tyreDetails[0].options.allSizes.indexOf(selectedWidth.value);
          if (optionIndex >= 0) {
            sizeSearch.tyreDetails[0].selected = {
              productMetafield: {
                namespace: sizeSearch.tyreDetails[0].metafieldNamespace,
                key: sizeSearch.tyreDetails[0].metafieldKey,
                value: selectedWidth.value,
              },
            };
            await sizeSearch.getOptions('tyre', 1);
          }
        }
      };

      const ensureWidthCascade = async () => {
        if (!selectedWidth.value) return;
        const hasAspectOptions = Array.isArray(sizeSearch.tyreDetails?.[1]?.options) && sizeSearch.tyreDetails[1].options.length > 0;
        if (!hasAspectOptions) {
          await handleWidthChange(false);
        }
      };

      const handleAspectRatioChange = async (resetDiameter = true) => {
        if (resetDiameter) {
          selectedDiameter.value = '';
        }
        if (selectedAspectRatio.value) {
          const optionIndex = sizeSearch.tyreDetails[1].options.indexOf(selectedAspectRatio.value);
          if (optionIndex >= 0) {
            sizeSearch.tyreDetails[1].selected = {
              productMetafield: {
                namespace: sizeSearch.tyreDetails[1].metafieldNamespace,
                key: sizeSearch.tyreDetails[1].metafieldKey,
                value: selectedAspectRatio.value,
              },
            };
            await sizeSearch.getOptions('tyre', 2);
          }
        }
      };

      const ensureAspectCascade = async () => {
        if (!selectedAspectRatio.value) return;
        const hasDiameterOptions = Array.isArray(sizeSearch.tyreDetails?.[2]?.options) && sizeSearch.tyreDetails[2].options.length > 0;
        if (!hasDiameterOptions) {
          await handleAspectRatioChange(false);
        }
      };

      const ensureDiameterCascade = async () => {
        if (!selectedWidth.value || !selectedAspectRatio.value) return;
        const hasDiameterOptions = Array.isArray(sizeSearch.tyreDetails?.[2]?.options) && sizeSearch.tyreDetails[2].options.length > 0;
        if (!hasDiameterOptions) {
          await handleAspectRatioChange(false);
        }
      };

      const handleDiameterChange = () => {
        if (selectedDiameter.value) {
          const optionIndex = sizeSearch.tyreDetails[2].options.indexOf(selectedDiameter.value);
          if (optionIndex >= 0) {
            sizeSearch.tyreDetails[2].selected = {
              productMetafield: {
                namespace: sizeSearch.tyreDetails[2].metafieldNamespace,
                key: sizeSearch.tyreDetails[2].metafieldKey,
                value: selectedDiameter.value,
              },
            };
          }
        }
      };

      const sizeFilterLoading = ref(false);

      const filterBySize = () => {
        if (selectedWidth.value && selectedAspectRatio.value && selectedDiameter.value) {
          sizeFilterLoading.value = true;
          const sizeDisplay = `${selectedWidth.value}/${selectedAspectRatio.value}R${selectedDiameter.value}`;
          selectedSizeDisplay.value = sizeDisplay;
          localStorage.setItem('selectedSizeDisplay', sizeDisplay);
          localStorage.setItem('selectedWidth', selectedWidth.value);
          localStorage.setItem('selectedAspectRatio', selectedAspectRatio.value);
          localStorage.setItem('selectedDiameter', selectedDiameter.value);

          const existingIndex = sizeHistory.value.findIndex((s) => s.display === sizeDisplay);
          if (existingIndex > -1) {
            sizeHistory.value.splice(existingIndex, 1);
          }

          sizeHistory.value.unshift({
            width: selectedWidth.value,
            aspect: selectedAspectRatio.value,
            diameter: selectedDiameter.value,
            display: sizeDisplay,
          });

          sizeHistory.value = sizeHistory.value.slice(0, 3);
          persistSizeHistory();

          vehicleSearch.clearActiveVehicle();

          showDropdown.value = false;

          const widthMeta = sizeSearch.tyreDetails?.[0] || {};
          const aspectMeta = sizeSearch.tyreDetails?.[1] || {};
          const diameterMeta = sizeSearch.tyreDetails?.[2] || {};
          const filters = [
            {
              productMetafield: {
                namespace: widthMeta.metafieldNamespace || 'wheel_tyre_spec',
                key: widthMeta.metafieldKey || 'width',
                value: selectedWidth.value,
              },
            },
            {
              productMetafield: {
                namespace: aspectMeta.metafieldNamespace || 'tyre_spec',
                key: aspectMeta.metafieldKey || 'aspect_ratio',
                value: selectedAspectRatio.value,
              },
            },
            {
              productMetafield: {
                namespace: diameterMeta.metafieldNamespace || 'wheel_tyre_spec',
                key: diameterMeta.metafieldKey || 'rim_diameter',
                value: selectedDiameter.value,
              },
            },
          ];

          localStorage.setItem('searchWidgetFilters', JSON.stringify(filters));

          window.dispatchEvent(
            new CustomEvent('vehicle-updated', {
              detail: {
                searchType: 'size',
                size: sizeDisplay,
                filters: filters,
              },
            })
          );

          navigateToTyresCollection();
        }
      };

      const filterByVehicle = () => {
        if (!vehicleSelector.value[3] || !vehicleSeries.value) {
          return;
        }
        const options = (vehicleSelector.value[3] && vehicleSelector.value[3].options) || [];
        const optionIndex = options.findIndex((opt) => {
          if (opt && typeof opt === 'object' && 'id' in opt) return String(opt.id) === String(vehicleSeries.value);
          return String(opt) === String(vehicleSeries.value);
        });
        if (optionIndex < 0) {
          return;
        }
        pendingVehicleFromSelector.value = true;
        pendingVehiclePreIds.value = vehicleSearch.vehicles.map((v) => String(v?.id || ''));
        pendingVehicleModal.value = true;
        vehicleSearch.selectTrait(3, optionIndex);
      };

      document.addEventListener('click', (e) => {
        const c = document.getElementById('GGvehicleDropdown');
        if (c && !c.contains(e.target)) showDropdown.value = false;
      });

      watch(() => uiState.openSizeSearch, (val) => {
        if (!val) return;
        uiState.openSizeSearch = false;
        showDropdown.value = true;
        changeTab('size');
        if (document.getElementById('headerNav')) {
          document.getElementById('headerNav').classList.remove('active');
        }
        if (document.getElementById('navMenu')) {
          document.getElementById('navMenu').classList.remove('active');
        }
        if (document.getElementById('headerHamburger')) {
          document.getElementById('headerHamburger').classList.remove('is-open');
        }
        if (document.getElementById('navHamburger')) {
          document.getElementById('navHamburger').classList.remove('is-open');
        }
        if (document.body) {
          document.body.classList.remove('dropdown-open');
        }
        if (document.getElementById('stickyHeader')) {
          document.getElementById('stickyHeader').classList.remove('header-collapsed');
        }
      }, { immediate: true });

      watch(clubRego, async (newClub) => {
        if (newClub) await resetTyreSizeSelect();
      })


      return {
        rego,
        showDropdown,
        toggleDropdown,
        vehicleSearch,
        formatVehicleDisplay,
        regoSearch,
        selectVehicle,
        selectSizeHistory,
        removeVehicle,
        removeSizeSearch,
        clearSelection,
        popup,
        isModalOwner,
        vehicle,
        noRego,
        yesRego,
        closePopup,
        retryRego,
        vehicleConfirm,
        noRegoInput,
        noStateInput,
        isDuplicate,
        checkDuplicate,
        vehicleLoad,
        activeTab,
        activeVehicleId: computed(() => vehicleSearch.activeVehicleId),
        activeVehicle,
        displayedVehicles,
        changeTab,
        sizeSearch,
        vehicleSelector,
        vehicleMake,
        vehicleYear,
        vehicleModel,
        vehicleSeries,
        pendingVehicleModal,
        bestDealsLink,
        isOnPromoPage,
        browseTyresLink,
        browseWheelsLink,
        browseServicesLink,
        handleVehicleSelect,
        selectedWidth,
        selectedAspectRatio,
        selectedDiameter,
        selectedSizeDisplay,
        sizeHistory,
        handleWidthChange,
        ensureWidthCascade,
        handleAspectRatioChange,
        ensureAspectCascade,
        ensureDiameterCascade,
        handleDiameterChange,
        filterBySize,
        filterByVehicle,
        sizeFilterLoading,
        pendingVehicleFromSelector,
        vehicleReady,
        canConfirmVehicle,
        confirmingVehicle,
        clubRego
      };
    },
  });

  app.use(window.VueAppGlobals.pinia);
  app.mount('#GGvehicleDropdown');
})();
